import { environment } from './../../../../../../environment/environment';
import { EsnCandidatService } from './../../../../../core/services/esn-candidat/esn-candidat.service';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, takeUntil } from 'rxjs';
@Component({
  selector: 'app-detailsuggestion',
  templateUrl: './detailsuggestion.component.html',
  styleUrls: ['./detailsuggestion.component.css'],
})
export class DetailsuggestionComponent {
  /* string */
  url: string = environment.baseUrl;
  /* number */

  /* number */
  totalItems!: number;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  /* object */
  image: any;
  selectedCandidate!: any;
  pagination : boolean =false;

  /* array */
  contratRequest = [
    { id: 1, name: 'Alternance' },
    { id: 2, name: 'Autres type de contrat' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
  ];
  skills: any = [];
  colorsHeader: string[] = [
    '#FBF2E9',
    '#E8F6FC',
    '#FDEFEE',
    '#FFF3D7',
    '#FBF2E9',
  ];
  idCandidat = this.activatedRoute.snapshot.params['id'];
  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private activatedRoute: ActivatedRoute,
    private candidatService: EsnCandidatService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {}
  ngOnInit() {
    window.scrollTo(0, 0);
    console.log(this.idCandidat);
    this.getCandidateById();
    this.getSkills();
  }
  /* get pagination items */
  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
        if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){          this.pagination = true

          this.getSkills();}
    }
  }
  /* get candidate id from route */
  //  getIdCandidat() {
  //    this.activatedRoute.paramMap.subscribe({
  //      next: (params: any) => {
  //        this.idCandidat = this.activatedRoute.snapshot.params['id']
  //        console.log('');

  //        this.getCandidateById()
  //      }
  //    })
  //  }
  /* get candidate by id */

  getCandidateById(): void {
    this.spinner.show();
    console.log('this.idcandidat', this.idCandidat);
    this.candidatService
      .getsuggestionById(this.idCandidat)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res: any) => {
          console.log('res', res);
          this.spinner.hide();
          this.selectedCandidate = res.data[0];
          console.log('selectedCandidate', this.selectedCandidate);
          this.image = res.data[0].image_url;
          console.log('image', this.image);
          this.selectedCandidate.current_country =
            !this.selectedCandidate.current_country ||
            this.selectedCandidate.current_country == 'null'
              ? ''
              : this.selectedCandidate.current_country;
          this.selectedCandidate.linkedin_link =
            !this.selectedCandidate.linkedin_link ||
            this.selectedCandidate.current_country == 'null'
              ? ''
              : this.selectedCandidate.linkedin_link;
          this.selectedCandidate.date_first_experience =
            !this.selectedCandidate.date_first_experience ||
            this.selectedCandidate.date_first_experience == 'null'
              ? ''
              : this.selectedCandidate.date_first_experience;
          this.selectedCandidate.desired_salary =
            !this.selectedCandidate.desired_salary ||
            this.selectedCandidate.desired_salary == 'null'
              ? ''
              : this.selectedCandidate.desired_salary;
          this.selectedCandidate.destination_country =
            !this.selectedCandidate.destination_country ||
            this.selectedCandidate.destination_country == 'null'
              ? ''
              : this.selectedCandidate.destination_country;
          //  this.parseData('certificat')
          //  this.parseData('desired_contract')
          //  this.parseData('diplome')
          //  this.parseData('mobility')
          let data: any = [];
          if (this.selectedCandidate.desired_contract?.length) {
            for (
              let index = 0;
              index < this.selectedCandidate.desired_contract.length;
              index++
            ) {
              const element = this.selectedCandidate.desired_contract[index];
              data.push(this.contratRequest[element].name);
            }
          }
          this.selectedCandidate.desired_contract = data;
        },
        error: (err: Error) => {
          this.spinner.hide();
        },
      });
  }
  //  parseData(name:string){
  //    if(typeof this.selectedCandidate[name] =="string" && this.selectedCandidate[name]=='null'){
  //      this.selectedCandidate[name]=[]
  //    }else {
  //      this.selectedCandidate[name]=JSON.parse(this.selectedCandidate[name])
  //    }
  //  }
  /* open pdf in new target blank */
  OpenPDF(typeFile?: string) {
    this.spinner.show();
    const fileUrl = !typeFile
      ? `${this.url}/api/User/file/gallery_cvs/${this.selectedCandidate.cv}`
      : `${this.url}/api/ResponseCandidate/GetFile/${
          this.selectedCandidate.file_test.split('/')[1]
        }`;
    this.candidatService.downloadPDF(fileUrl).subscribe((blob) => {
      const fileURL = URL.createObjectURL(blob);
      this.spinner.hide();
      window.open(fileURL, '_blank');
    });
  }
  /* download file */
  downloadFile(typeFile?: string) {
    if (typeFile && typeFile != '')
      this.selectedCandidate.file_test =
        this.selectedCandidate.file_test.split('/')[1];
    this.spinner.show();
    const fileUrl = !typeFile
      ? `${this.url}/api/User/file/gallery_cvs/${this.selectedCandidate.cv}`
      : `${this.url}/api/ResponseCandidate/GetFile/${this.selectedCandidate.file_test}`;
    this.candidatService.downloadPDF(fileUrl).subscribe((blob) => {
      const fileURL = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = fileURL;
      a.download = !typeFile
        ? `${this.selectedCandidate.ID_user}_${
            this.selectedCandidate.first_name
          }_${
            this.selectedCandidate.last_name
          }_CV.${this.selectedCandidate!.cv.split('.').pop()}`
        : `${this.selectedCandidate.ID_user}_${
            this.selectedCandidate.first_name
          }_${
            this.selectedCandidate.last_name
          }_QCM.${this.selectedCandidate!.file_test.split('.').pop()}`;
      document.body.appendChild(a);
      a.click();
      this.spinner.hide();
    });
  }
  /* get candidate skills */
  getSkills() {
    this.candidatService
      .getSkillsCandidate(this.idCandidat)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.skills = res.data.categoriesWithSubCategoriesAndSkills.slice(
            0,
            this.endIndex
          );
          this.totalItems = res.data.count;
        },
        error: (error) => {
          console.log(error);
          // this.toastr.error(serverError)
        },
      });
  }
  updateCandidate() {
    this.router.navigate([
      'candidats/profil-candidat/update',
      { idCandidat: this.selectedCandidate.id },
    ]);
  }
  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
